import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { NewActionTaxonomyActionComponent } from '../new-action-taxonomy-action/new-action-taxonomy-action.component';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';

declare var gtag;

@Component({
  selector: 'kla-new-action-taxonomy-strategy',
  templateUrl: './new-action-taxonomy-strategy.component.html',
  styleUrls: ['./new-action-taxonomy-strategy.component.scss'],
  standalone: true,
  imports: [ CommonModule, MatExpansionModule, NewActionTaxonomyActionComponent, DynamicContentComponent ]
})
export class NewActionTaxonomyStrategyComponent implements OnInit {


  @Input() strategy;
  @Input() color: any;
  @Input() includeTier: any;
  @Input()
  public config: any;
  @Input() parentGoalTitle: any;
  @Input() parentCategoryTitle: any;
  panelOpenState: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  handleOpened() {
    this.panelOpenState = true;
    this.trackExpansion();
  }

  handleClosed() {
    this.panelOpenState = false;
  }

  private trackExpansion() {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'action_taxonomy_expanded', {
        'expanded_level': 'strategy',
        'new_visible_level': 'action',
        'expanded_level_title': this.strategy.title,
        'child_count': this.strategy.list?.length || 0,
        'parent_goal_title': this.parentGoalTitle,
        'parent_category_title': this.parentCategoryTitle
      });
    }
  }

  addAlpha(color: string, opacity: number, device: string = 'xl'): string {
    if (device != 'xs' || this.isMobile()) {
      const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
      return color + _opacity.toString(16).toUpperCase();
    } else {
      return;
    }
  }

  isMobile() {
    return window.innerWidth < 767;
  }


}
